import campaignConfig from '../../campaign-config/campaign.json';

export const globalColors = campaignConfig.global?.colors || {};
export const globalBackgrounds = campaignConfig.global?.backgrounds || {};
export const globalText = campaignConfig.global?.text || {};

export const tutorEndConfig = campaignConfig.tutor_end || {};
export const tutorHomeImages = campaignConfig.tutor_home?.images || {};

export const resolveTutorEndAsset = (asset) => asset;
